import { render, staticRenderFns } from "./ac-mentions.vue?vue&type=template&id=b1f55b02&"
import script from "./ac-mentions.vue?vue&type=script&lang=js&"
export * from "./ac-mentions.vue?vue&type=script&lang=js&"
import style0 from "./ac-mentions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports